import React, { useEffect, useState } from "react";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
// import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@material-ui/core";

import AppInput from "../../../../../components/Input/AppInput";
import AppButton from "../../../../../components/CustomButtons/AppButton";

import { getAuthInfo } from "store/slices/auth";
import { SYSTEM_ROLE } from "config/AppConfig";
import { fetchCompanyUserDetail } from "store/slices/companyUser";
import { reduceUpdateCompanyUser } from "store/slices/companyUser";
import AppConfirmDialog from "components/Dialog/AppConfirmDialog";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import ChangeEmailForm from "views/Company/AccountSetting/Components/ChangeEmailForm";
import { changeEmail } from "store/slices/auth";
import { getMe } from "store/slices/auth";
import AppConfig from "config/AppConfig";
import { updateFirstLastName } from "store/slices/auth";
// import { YupValidations } from "utils/validate";

const { PATTERNS } = AppConfig;

const CompanyUserDetailForm = () => {
  const { t } = useTranslation();
  // const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(getAuthInfo);
  const { socialLogin } = user;

  const [showConfirmChangeEmail, setShowConfirmChangeEmail] = useState(false);
  const [showChangeEmailModal, setShowChangeEmailModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [initializeData, setInitializeData] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });
  const _submit = (data) => {
    let request = {
      firstName: data.firstName,
      lastName: data.lastName,
      id: user.id,
      permissions: user.permissions,
    };
    if (user.role === SYSTEM_ROLE.COMPANY) {
      request.companyId = user.companyId;
    }
    setSubmitting(true);
    dispatch(reduceUpdateCompanyUser(request)).then(() => {
      setSubmitting(false);
      dispatch(getMe());
      dispatch(updateFirstLastName({
        firstName: data.firstName,
        lastName: data.lastName
      }))
      _loadData();
    });
  };

  const _loadData = () => {
    let request = { id: user.id };
    if (user.role === SYSTEM_ROLE.COMPANY) {
      request.companyId = user.companyId;
    }
    dispatch(fetchCompanyUserDetail(request)).then(({ payload }) => {
      if (payload) {
        setInitializeData({
          ...initializeData,
          firstName: payload.firstName || "",
          lastName: payload.lastName || "",
          email: payload.email || "",
        });
      }
    });
  };
  const _handleOpenChangeEmailModal = () => {
    // history.push('admin/change-email');
    setShowConfirmChangeEmail(false);
    setShowChangeEmailModal(true);
  };

  const handleChangeEmail = async ({ email }) => {
    setShowChangeEmailModal(false);
    if (email) {
      const result = await dispatch(
        changeEmail({
          id: user.id,
          email: email.trim(),
        })
      );
      if (result.payload) {
        dispatch(getMe());
      }
    }
  };

  useEffect(() => {
    _loadData();
  }, []);
  return (
    <Box>
      <Formik
        initialValues={initializeData}
        validationSchema={Yup.object().shape({
          firstName: Yup.string()
            .required("validation.first_name.required")
            .max(64, "validation.max_length_64")
            // .matches(PATTERNS.XSS_PATTERN, 'validation.xssPatterns')
            .matches(PATTERNS.BLANK_SPACES, "validation.blankSpaces"),
          lastName: Yup.string()
            .required("validation.first_name.required")
            .max(64, "validation.max_length_64")
            // .matches(PATTERNS.XSS_PATTERN, 'validation.xssPatterns')
            .matches(PATTERNS.BLANK_SPACES, "validation.blankSpaces"),
          email: Yup.string().trim()
              .required('validation.email.required')
              .email('validation.email.invalid')
              .max(255, { message: 'validation.max_length', value: 255})
              .matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces')
        })}
        onSubmit={_submit}
        enableReinitialize
      >
        {({ handleSubmit }) => (
          <>
            <Field
              component={AppInput}
              name="firstName"
              label={t("label.first_name")}
              required
            />
            <Field
              component={AppInput}
              name="lastName"
              label={t("label.last_name")}
              required
            />
            <Field
                  component={AppInput}
                  name="email"
                  label={t("label.email")}
                  required
                  disabled
            />
            {!socialLogin &&
                <Box>
                  <AppButton
                    label={t("label.changeEmail")}
                    onClick={() => setShowConfirmChangeEmail(true)}
                  />
                </Box>
            }
            <Box
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
              mt={3}
            >
              {/* <AppButton
                label={t("button.back")}
                onClick={() => history.goBack()}
                mode="outlined"
                style={{
                  marginRight: "1rem",
                }}
              /> */}
              <AppButton
                label={t("button.save")}
                onClick={handleSubmit}
                isLoading={submitting}
                disabled={submitting}
              />
            </Box>
          </>
        )}
      </Formik>
      <AppConfirmDialog
        open={showConfirmChangeEmail}
        onConfirm={() => _handleOpenChangeEmailModal()}
        onClose={() => setShowConfirmChangeEmail(false)}
        title={t("title.confirmChangeEmail")}
        content={t("text.confirmChangeEmail")}
      />
      <Modal
        isOpen={showChangeEmailModal}
        onClosed={() => setShowChangeEmailModal(false)}
        style={{ width: "auto", height: "auto" }}
      >
        <ModalHeader style={{ backgroundColor: "#59d5b2" }}>
          <span style={{ color: "#FFFFFF" }}>{t("title.changeEmail")}</span>
        </ModalHeader>
        <ModalBody>
          <ChangeEmailForm
            onSubmit={handleChangeEmail}
            onClose={() => setShowChangeEmailModal(false)}
          />
        </ModalBody>
      </Modal>
    </Box>
  );
};

CompanyUserDetailForm.propTypes = {};

export default CompanyUserDetailForm;
